var Audio = require('../../lib/audio.js');
var Cards = require('../../lib/cards.js');
var VideoPlayer = require('../../lib/video-player.js');
var VideoModal = require('../../lib/video-modal.js');
var VideoThumbnails = require('../../lib/video-thumbnails.js');

module.exports = function() {
    /**
     * Cards
     */
    var cards = new Cards;
    cards.setup('ul.cards', 'li', 'fitRows');

    /**
     * Audio
     */
    var audio = new Audio;
    audio.setup('jp-jplayer');

    /**
     * Video
     */
    var videoPlayer = new VideoPlayer;
    var videoModal = new VideoModal;
    var videoThumbnails = new VideoThumbnails;

    videoPlayer.setup('video-js-standalone');
    videoModal.setup('play-video');
    videoThumbnails.setup('preview-container.video');
};
